export default {
	chinese: '简体中文',
	english: 'English',
	japanese: '日本語',
	title: 'Log in with Oscar',
	french: 'Français',
};
